
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1f5b645a75d5c5ac': html`
            <p>
              Como parte de sua integração, você precisará fornecer algumas configurações iniciais para sua conta antes de poder começar a vender seus serviços.
            </p>
            <p>
              Quando estiver pronto(a), clique aqui (isso o levará para a página de configurações).
            </p>
          `,
'hcd9d4fc56615709f': html`TREINE INTELIGENTE • FIQUE EM FORMA • SEJA PRO`,
's005053d82b712e0a': `Anotações`,
's019efedacc31ba10': `perdido`,
's0279db1c6f449ab7': `Análises de Negócios`,
's02cf66a0a0653ff8': `Detalhes do Registro de Treino`,
's05a351a51219b0fe': `Ninguém`,
's06e80315ac9995b9': `Nenhum ainda`,
's091d3d07b5b3076f': `OK`,
's09b77ef3824e4088': `Água Corporal Total`,
's0a2ca898b54a4f56': `Bem-vindo(a)!`,
's0c442cbbc17f0de9': `Por favor, faça login para continuar.`,
's0c7f3e5e3c15f428': `Continuar sessão`,
's0ce7d9675a8b7732': str`3. Prazos ${0} condições`,
's0ec54510233409c5': `Falha ao publicar plano: `,
's0fbf6dc6a1966408': `Próximo`,
's0fe87ed1fc09cf34': `Seu logo também será usado como sua foto de perfil.`,
's1150c078d9cee26d': `% de Gordura Corporal`,
's12efa94f2e4bdcc3': `Repetições`,
's12ffcaf2e502ac82': `falha sem arquivo`,
's13a2e3afa0779b53': `Planos`,
's13cefa7424ff2e27': `Filtrar alunos`,
's15e23319b09fd2e3': `IMC`,
's192f232455c1b65d': `Annexar embaixo`,
's19f8a91fef089a4a': `Assinatura:`,
's1a73a3c2401c31ea': `Bem-vindo(a) aqui!`,
's1bf0c7472ae25a6f': `Quase lá — ainda falta:`,
's1bf9fe1883d69bf9': `Para melhores resultados, use logos de 200 x 200 pixels e no formato SVG. No entanto, arquivos nos formatos webp, jpg e jpeg também são aceitos.`,
's1d318e9d0ccba86b': `Chat`,
's1e05ab3c077ad402': `Alternativa: Bioimpedância / InBody`,
's1e187119b5262c59': `Máx`,
's1f7698c061c208c9': `Abrir`,
's2011fc99c027dbb1': `dias de sequência`,
's203e1da56bd2e626': str`${0}semanas`,
's215ad519258e9d97': `agora`,
's217f47ce4db59c2e': `Massa Livre de Gordura`,
's21b06c38fc4164db': `Avançado`,
's222859294d7fb3a3': `Filtrar planos`,
's230cf829634bac2a': str`Ombros`,
's2350bef19b9f2588': `Envio de fotos`,
's24b779bb2fb9847b': str`Prazo: ${0}`,
's262463042abb35d7': `Obrigado! Suas respostas foram registradas.`,
's2626be9fb3554c7d': `Copiar seções seguintes`,
's26db9189a75bef43': str`${0} Novos`,
's26f4e57f53965b7c': `Aluno desconhecido`,
's26f55ad32da5d49c': `Requer atenção`,
's26fceaca777a7b8d': `Nenhum Exercício`,
's2840abad0770c57b': str`Panturrilhas`,
's2a87c777df650b17': `Assinatura mensal`,
's2accc8370816a278': `exercícios`,
's2b0df9e2b26a4f87': `Academia Completa`,
's2b9d55453f4356bb': `URL do YouTube:`,
's2c86969637ae0fe3': `Entrega do treino`,
's2ceb11be2290bb1b': `Cancelar`,
's2d5ebf2d00a77043': `próximo`,
's2dacbbc50eda12a6': `É preciso ter ciência de que, na ausência das avaliações citadas, algumas informações importantes não serão consideradas e a consultoria acontecerá, porém poderá ter sua eficiência reduzida.`,
's2e51ab74561f5024': `Selecionar Cliente`,
's2ed82ff088ba5782': `Termos e Condições do Provedor de Serviços do Treinador`,
's2ef90cfc73edcac2': str`Ver todos (${0})`,
's2f3dd8b8ea2006fb': `Nenhum treino disponível ainda`,
's2fccc807af87ee35': `Progresso Semanal`,
's305c088da2474ea2': `Perguntas`,
's307ebbf519f93ea5': `Última sessão`,
's30959594f2efe182': `Cliente desde:`,
's30fba8ef68ba39e7': `Nome do Treino:`,
's3375a4920652b810': `Séries`,
's33f85f24c0f5f008': `Salvar`,
's356afc5e8bdabfb3': `Entregar`,
's3651ca5688e7b9d8': `Falha ao salvar o plano`,
's3687049d1af562c4': `Copiar`,
's382a2aa3984474dd': `Criar`,
's388be1e86199883f': str`${0} em aberto`,
's38e8273daf1ff536': str`Treino ${0}`,
's395b013b1b16b33f': `Concordo com os Termos de Serviço do meu treinador.`,
's399cc2d67d92e957': `Confidencial`,
's3a03fffca0dbc126': `Nenhuma ação pendente`,
's3afaa4fbbbc61a5c': `Perda de Peso`,
's3bbe3ec0204334f9': `Termos e Condições de Uso do TrainFitPro`,
's3d69183691314fd8': str`${0}h`,
's3f578e92d19ba2fc': str`Vista frontal - ativos: ${0}`,
's3fafae6168b9e553': str`${0} treinos`,
's42371020b1129113': `Hipertrofia`,
's427dc85ddc28b8e7': `Descreva cirurgias anteriores, dores articulares (ombro, joelho, coluna) ou qualquer restrição médica importante…`,
's4295bddca90bec76': str`Peito`,
's42bc0e4e1a6c3e62': `Obrigatório`,
's4312bcbe1a680288': `Reabilitação`,
's445e9135e4c219ae': `Massa Muscular`,
's44629f179e18b32f': str`Salvar ${0} Continuar`,
's45274a2e84266fa0': `Por favor, aceite abaixo (aceitando também os Termos e Condições do Treinador)`,
's455a725a7c83d8ac': str`#${0} em faturamento`,
's467b030b9a34b3c8': `Média`,
's46d6587089bd0356': `Próximo mês`,
's46ec6540ada4ea9b': `Sumário`,
's48adf6580103ef59': `Por favor, revise os Termos e Condições e a Política de Privacidade antes de se inscrever.`,
's48e186fb300e5464': `Tempo`,
's4908d5eb206e4557': `Seu logo, por exemplo, ficará assim:`,
's4911f2c56a916d5d': str`Nome do Plano:`,
's4ab2d3cc63bec077': `Pré-visualização:`,
's4abcddbf0c24a4e2': str`há ${0}d`,
's4b8e5ca433fe9a85': `Pagamento Atrasado/Em Breve`,
's4da7b16439206463': `Planos Atrasados/Próximos`,
's4ec95ab5f10e0b0d': `Rascunhos`,
's4f299dd888a2df8f': `A captura de tela aparecerá nesta caixa.`,
's4f99f3802d8a5872': `Medição das 7 ou 9 dobras cutâneas + perimetria ou bioimpedância completa. Caso não seja possível, realizar a InBody machine.`,
's4fe76110dab46192': `Falha ao salvar o plano: `,
's501040845af84498': `Pausa`,
's509ec2f4900e39b4': `Biometria`,
's517acbf1f96324f9': `Musculação`,
's51a431d68ff7c47b': `Continuar com o Google`,
's536db73f020e2ae0': `Transmissão de vídeo indisponível.`,
's539b014cd449ae45': `Relação Cintura-Quadril`,
's53e04be816af4a73': `Entrega`,
's54b533d717a48b22': `20 dias`,
's554a1cea9b6d9afd': `É desejável uma avaliação física com medição das 7 ou 9 dobras cutâneas + perimetria ou bioimpedância completa.`,
's55a007290e2b73f1': `A seguir`,
's55d09572312d435d': str`${0} Ativos`,
's58c19d887aafd7a5': `Iniciar nova sessão`,
's58d7e2a809948cdd': `Vestimenta adequada`,
's590ec3849dee58d1': `As fotos devem ser realizadas em trajes de banho (biquíni ou sunga).`,
's595fe6f3b8aaa6a9': `Simulação de Plano`,
's59675d3bb2b7b629': `Descrição:`,
's59d8decc425c79b0': `Infelizmente, você não está autorizado a usar este aplicativo. Por favor, sinta-se à vontade para verificar novamente em uma data posterior.`,
's5b177391f91aa762': str`Vista posterior - ativos: ${0}`,
's5b3ea8291adf04ec': `Para uso futuro`,
's5cd3748fb8081f0b': `Objetivo Principal`,
's5cdcc3c2505d0a32': `Seu resultado de treino foi salvo`,
's5d8b4ca459b9a978': `Diário`,
's5dc4d095d9970f7e': str`${0}dias`,
's5e8250fb85d64c23': `Fechar`,
's5f4134772e7bb890': `Ver toda a atividade`,
's5f4586bc1e2740e6': `Limpar pesquisa`,
's60cc10ca9e096620': `Oficial`,
's62931b2a50168976': `Mês anterior`,
's631ed9c4eef50981': `Métricas de Serviço`,
's63461adc1045292c': `Iniciar treino`,
's6430981650a5df60': `Equipamento Disponível`,
's65b179f701078347': `Nenhuma pergunta`,
's66413c24dcf680e2': `Pular`,
's664ccd1b2b37fccc': `Pagamentos Atrasados/Próximos`,
's67749057edb2586b': `Sair`,
's6778df312dec45f0': `Somente Peso Corporal (Calistenia)`,
's6884ff7dcc93619f': `Seletor de Aluno`,
's68f932d22e504054': `Mobilidade`,
's6a2844e7aaa48d5c': str`Média de sessões de treino por semana: A Definir`,
's6a67c73c319177f1': `O plano foi publicado`,
's6a8e33eda365346e': `É assim que ficará:`,
's6aa7ad9440de4905': `a contar da data de pagamento`,
's6ad744e56c5f3a42': `Envie seu logo`,
's6b269e8e8e93d748': `Eu aceito os Termos e Condições e a Política de Privacidade.`,
's6c10576661997054': `Nome:`,
's6d08351212b63683': `Configurar sua Anamnese`,
's6d3b5b0561ba34c9': `Publicados`,
's6d7efb5ab40b33b4': `Assinatura`,
's6de3d6e9660857a1': `Exemplo`,
's6fa7fe2095471e0b': `Peso Corporal`,
's70478974fa7eccb4': `Massa Gorda`,
's708334df3634ad8b': `Avaliação Inicial`,
's72b0e48e2a286710': `Perguntas do seu Treinador`,
's73280c5c08612b65': `Ocorreu um erro durante o salvamento: `,
's7383555c44bf3d93': `Criar pasta`,
's74982e57a1d8896c': `Configurações Avançadas`,
's7707a80d4dc2ad6f': `Li e estou ciente de todas as instruções, trajes recomendados e prazos estipulados pela consultoria.`,
's773f2473fde48117': `Vendas`,
's77bd3ee683e4f8c2': `Altura e centralização da câmera`,
's77dde5ef6c52def6': `Moeda`,
's78104df0504716a8': `Seletor de Mídia`,
's79e8cc71a5975b04': `Mensagem`,
's7d53050a50cff2fc': `Não realize nenhum corte ou edição nas fotografias. Caso as fotografias estejam fora do padrão, deverão ser refeitas.`,
's7da0c77635fbed00': `Tem certeza que deseja excluir estas seções/treino?`,
's7df56dd45cc6277f': `Observações de hoje`,
's7ee8cdf05d4fbb1d': `Muito longo`,
's7f3437809d931336': `Revisões`,
's818f17de976629e1': `Salvando...`,
's81d30c913ed714f6': `Escolha seus termos:`,
's81ecf2d4386b8e84': `Continuar`,
's81f8e4b4a6dcfd17': str`Dorsais`,
's826b68dbee24a53f': `Ao Vivo`,
's83521d49a1b58158': `Gerenciador de Mídia`,
's85186a61e0d55bac': `Vídeo`,
's855293e72dd930fa': `Nome do Exercício`,
's8578c6253fc59879': `Experiência de Treino`,
's878d4efff55e28ec': `Diário`,
's89e396ff03e2a702': `A câmera deve estar na altura do seu quadril e bem centralizada (nas fotos no chão, câmera no chão também, no meio do seu corpo). Caso alguém tire para você, peça que a pessoa se sente em uma cadeira.`,
's8ab070f3fa0ae40b': str`Histórico Médico ${0} Limitações`,
's8b0432eecbd8b034': `Atualizar`,
's8b97ea84af17c029': `Nunca`,
's8c1837e74a81ad0d': str`há ${0}m`,
's8df195c27586582e': str`${0} dias para o prazo do plano`,
's8fae5de4533e1b4c': `Cliente:`,
's900f0929459f61e9': `Concordo com os Termos de Serviço e a Política de Privacidade da plataforma.`,
's9103a7851a988739': str`Halteres ${0} Bancos em Casa`,
's928fcb256b35c21e': `Nenhum plano selecionado`,
's92921878e886e36d': `Duração`,
's92a0d19a28995530': `Sucesso`,
's92f6b4aa709c97a6': `Corpo inteiro (pés à cabeça)`,
's92f757b31c9251d5': `O não envio das fotos no prazo de 20 dias a partir da data de pagamento configura abandono da vaga, sendo indispensável realizar um novo pagamento de sinalização para reativá-la. Em caso de desistência da consultoria por parte do aluno, não haverá devolução do valor pago.`,
's937419baa2473f73': str`${0} dias após o prazo do plano`,
's9435457c0d47ca15': str`Bem-vindo(a) ${0}`,
's95fbda399bb97206': `Pagamentos`,
's96668830629e0dfc': `Enviar`,
's96e17d77681b5b4c': `Frequência Semanal`,
's970895c07251f7cf': `Disciplina`,
's99858602e18ca08c': `Configurar suas Métricas de Serviço`,
's99fa943a22c13e67': `Explorar`,
's9a06e76cc4d72a0d': str`Lombar`,
's9ae739bba204c8b9': str`Isquiotibiais`,
's9b06b628da2c361d': `Pesquisar…`,
's9b3033813c8d813f': `Início:`,
's9d0918cba6fff4a9': `Voltar para a página de login`,
's9d0ad7d89be68710': str`Olá ${0}`,
's9d8b8aa2b404c2c8': `Configurações`,
's9ebf600d37322503': str`Trapézio`,
's9fe64b90c760379e': `Publicando...`,
'sa06e60ff826e4c2a': `Importante sobre atrasos e desistência`,
'sa1664c25091fa385': `Parabéns por concluir sua sessão de treino`,
'sa18421c24fe0e455': str`Oblíquos`,
'sa2f16f3d642af032': `Métrica de plano`,
'sa31966cbbb99c765': str`Treinos de ${0} ${1}`,
'sa38ee475e1cf8a87': str`Quadríceps`,
'sa53c1dc8336bb9f0': `Biomecânica`,
'sa6a49e20c2bb1d36': `Registre-se com o provedor de pagamento e forneça a configuração.`,
'sa6f091b5420239ee': str`Protocolo de Biometria ${0} Avaliação Físico-Postural`,
'sa701dab6cda5cc99': `Treinos dos alunos`,
'sa75be35c199bd66e': `Nenhuma sequência ainda`,
'sa7b534c9d0d50518': `Nenhum novo`,
'sa835bf6d362a9e2a': `Detalhes do Treino`,
'sa86c00822bc55c28': `Seu logo será geralmente usado como um quadrado.`,
'sa86ea054ad5277ce': str`há ${0}h`,
'saafb40b251029280': str`Foto ${0}/${1}`,
'sab35bad30d0f7621': `Para esses treinos`,
'sab82b3493b817037': `Configurar informações de preços`,
'sab97bbe86d4cf4fe': str`Diagnóstico`,
'sac4f71b0ddb45d28': `Nenhum ativo`,
'sad3a2d2a8a492607': `Iniciante`,
'sadab6bd5bd26fc3c': `O plano foi salvo`,
'sadcec236f39d307e': `Mídia selecionada:`,
'sae4e38f41939b1ae': `1. Para começar`,
'sae5d87e99fe081e0': `Obrigatório`,
'sb02dad2922157cbc': str`${0} Sem resposta`,
'sb0abfc899f7e4275': `Avaliação física`,
'sb2e14cf8b4f7b963': `Protocolo de avaliação física`,
'sb39c29728a3aab64': `Intermediário`,
'sb3d2d8e2a3cedc49': `Configure seus Termos de Serviço`,
'sb5526ccbe8ba805f': `Por plano`,
'sb65c789c0a5ab012': `Esse processo é primordial para a montagem do seu treino, por isso, capriche!`,
'sb788a72b606be4bb': `Eu aceito os Termos e Condições e a Política de Privacidade do Treinador.`,
'sb8a63343939caf0d': `2. Padrão fotográfico`,
'sb940896159f93891': `Nenhum pendente`,
'sb9d1f408dc81dd97': str`Avaliação Inicial ${0} Prescrição`,
'sba5b7a8f4f902926': `Treino concluído!`,
'sbb94361ed4568464': str`Antebraços`,
'sbbb2f46c5f00dbf0': `Fim:`,
'sbca15f638701d792': `Condicionamento`,
'sbd465ea9bd2a1498': `Objetivo`,
'sc09f68b387d96596': `Requisitos iniciais`,
'sc31690556c9b1f9b': `Suas respostas moldam diretamente sua periodização de treino, descanso e intensidade biomecânica.`,
'sc360b1d435428cb1': `Revisões de Vídeo`,
'sc3da2b6f02afab19': str`Bíceps`,
'sc68080ce046320cb': `Atrasados`,
'sc8002664eec439d7': `Cardio`,
'sc8379accd3fbc340': `Treinador Oficial`,
'sc9da556492c87421': `Gerenciador de Alunos`,
'sc9e36319670bfb2c': `Nenhuma mensagem ainda`,
'sca10e25b4cf014c2': str`Iniciar Envio de Fotos (1/${0})`,
'scb837422e05acc02': `Metabolismo Basal`,
'scbd8031e3d026dc9': `nunca`,
'scc7a3682dd25ae19': `Opcional`,
'sccf853136930cdcb': `Digite o nome do plano ou do aluno`,
'scd7b43bc6ecb4dc0': `Seu treinador`,
'scea321ca3da7a0d6': `Filtrar por status`,
'scfcffcf35292bc6f': `Simular`,
'sd18e54cff4a91578': `Enviar Mídia`,
'sd1aede1413271800': `Tipos de frequências de pagamento oferecidas`,
'sd31a11e89b9882c2': `Cariello Academy`,
'sd3f6a8d871bcddec': str`${0} para ${1}`,
'sd4647caeb94889ec': `Termos`,
'sd5683140bd6412b7': `Dias dedicados`,
'sd56b740816b8f863': `Séries (separadas por vírgula)`,
'sd57e22d10c6d1167': `Infelizmente, você encontrou um erro no aplicativo. O erro foi registrado e estamos trabalhando para resolver o problema.`,
'sd593bc8a3c220ed2': str`Atrasado ${0} dias`,
'sd6cd4f2ac3777759': `Peso:`,
'sd6ddac8adb73147d': `Ocorreu um erro ao salvar: `,
'sd8245bf18e9d2136': `Personalize sua jornada de treino`,
'sd97345198e73f26c': `ERRO`,
'sda05a2d4cdf1fa30': `Falha durante a publicação do plano, já publicado?`,
'sdafe5c93c20d2066': `Ocorreu um erro durante a publicação: `,
'sdb39991315523ef4': `Sem cortes ou edições`,
'sdb9694f31d64cfc8': `Sua resposta`,
'sdc0a98f90dcd8e8b': `Publicar plano`,
'sdc12d4d35420eeb7': `Anotações`,
'sdc673e73b5c13aea': `Excluir`,
'sdcdd12bef40e339e': `YouTube`,
'sde5b338d06c7957a': `Termos e Condições do Treinador`,
'sde75a191a5b33d9d': `As fotos precisam estar em uma distância na qual seja possível visualizar dos seus pés até sua cabeça.`,
'sdf13400f7244ec63': `SLA da consultoria`,
'sdf9d3ebb59974cdf': `Tarefas`,
'se0f2aaae51472ca4': `Eu aceito os Termos e Condições e a Política de Privacidade do TrainFitPro.`,
'se11c5a35b7c2f7e3': str`Tríceps`,
'se2eaf692ffa79456': `Alongamento`,
'se3f7057c15a6332d': `Voltar para a página inicial`,
'se449f1215ef49707': `Atividade Recente`,
'se59701fa8cbad9a9': `Selecione treinos e exercícios`,
'se70419f87c03926e': `Continuar plano salvo ou pular`,
'se7dbe9f0dcd4b207': `Conclusão`,
'se9e2b9ef470e7ee4': `Escolha seu logo:`,
'seaa9f673a49ff037': `Caso não seja possível, realizar a avaliação na InBody machine e anexar o relatório completo.`,
'seadc1710dddab9e2': `Métrica de perguntas`,
'sebabfcac377bce0c': `Métrica de revisão de vídeo`,
'secb6e418f6aee0ac': `Nascimento:`,
'sed0a610da2d865be': `Falha durante a atualização, publicação do plano`,
'sed413c5e180d6edb': `Receita`,
'seed76e8afe9f604a': `Preço`,
'sef5248c6cf6b0068': `Inscreva-se nos serviços de`,
'sef7848f0523aff43': `Calendário de sequência de treinos`,
'sefcf950b3cc4fc3b': `Idioma`,
'sf0765e244cd21df0': `Detalhamento dos exercícios`,
'sf2001d4551fa38ca': `Seu treinador revisará sua anamnese e retornará em breve.`,
'sf2fec0d6b852774c': `Importar plano existente`,
'sf3a729179a574a75': `Nenhum item pendente`,
'sf3cacc3f38fd080c': `Vencendo em breve`,
'sf3ff78cc329d3528': `Anterior`,
'sf404dc6e56b8cfca': `Peso em kg`,
'sf5cd13af5eb03760': `Configurar sua Avaliação`,
'sf5dc01a3ccf20c4a': str`Série ${0}`,
'sf5f7f77ab9c1baaa': `Alterar foto de perfil`,
'sf6c15fd6d6110c75': `Leia as instruções e marque a caixa acima para iniciar o envio das fotos.`,
'sf87feb4049f6f275': `Treinos`,
'sf993bb199fefbe04': `Todos`,
'sf9aee319a006c9b4': `Adicionar`,
'sf9c2d219a01755db': str`Abdômen`,
'sfc4444d68ac3a49f': `a partir do envio das fotos`,
'sfc63e31ac7c956ed': `Selecionar`,
'sfcd2e536e51f1567': str`Glúteos`,
'sfd3f66de651ccd9f': `Progresso do Envio:`,
'sfdde30c24ce38292': `concluído`,
'sfe17eee9aeb43052': str`${0} Pendentes`,
'sfe9a2c05e71c261a': `Treinos Concluídos`,
'sfec9c11e84f72d03': str`Vencendo em ${0} dias`,
'sff0c83419b929db1': `Pesquisar alunos…`,
'sff5bb7742c2896c8': `Meta`,
    };
  